import React from "react";
import { Stack } from "react-bootstrap";
import { TIMING_LIST_ITEM } from "../TimingList.renderer";
import { ITimingListProps } from "../TimingList.types";
import {
  toCSSODateString,
  isNullOrUndefined,
} from "../../../../../shared/utils/data.utils";
import { TimingLabel } from "../../../../../shared/enums/labels.enums";

const DEFAULT_TIMING_STACK: React.FC<ITimingListProps> = (
  props: ITimingListProps
) => {
  const { timing } = props;

  return (
    <Stack data-testid="timing-list-stack">
      <TIMING_LIST_ITEM
        label={TimingLabel.PROJECTED_END_DATE}
        value={toCSSODateString(
          /* istanbul ignore next */ timing?.projectedEndDate ?? null
        )}
      />
      <TIMING_LIST_ITEM
        label={TimingLabel.REQUESTED_BY_DATE}
        value={toCSSODateString(
          /* istanbul ignore next */ timing?.requestedByDate ?? null
        )}
      />
      <TIMING_LIST_ITEM
        label={TimingLabel.ESTIMATED_SITE_READY_DATE}
        value={toCSSODateString(
          /* istanbul ignore next */ timing?.siteReadyDate ?? null
        )}
      />
      <TIMING_LIST_ITEM
        label={
          /* istanbul ignore next */ !isNullOrUndefined(
            timing?.daysOffSchedule
          ) && timing.daysOffSchedule > 0
            ? TimingLabel.AHEAD_OF_SCHEDULE
            : TimingLabel.BEHIND_SCHEDULE
        }
        value={
          /* istanbul ignore next */ !isNullOrUndefined(timing?.daysOffSchedule)
            ? `${Math.abs(timing?.daysOffSchedule)} Business Day(s)`
            : ""
        }
      />
      <TIMING_LIST_ITEM
        label={TimingLabel.NEXT_SCHEDULED_CONTACT}
        value={
          /* istanbul ignore next */ `${timing?.nextCeContact?.timeAmount} Business Day(s)`
        }
      />
    </Stack>
  );
};

export default DEFAULT_TIMING_STACK;
